export const BASE_DELAY_MS = 1_000;
export const MAX_DELAY_MS = 30_000;

const FACTOR = 2;
const JITTER = 0.2;

/**
 * `min(30s, 1s × 2^attempt)` with ±20 % jitter. The jitter is what keeps a fleet
 * of tabs that all dropped on the same deploy from reconnecting in lockstep.
 * `random` is injectable so the schedule is assertable.
 */
export function reconnectDelayMs(attempt: number, random: () => number = Math.random): number {
  const capped = Math.min(MAX_DELAY_MS, BASE_DELAY_MS * FACTOR ** attempt);

  return Math.round(capped * (1 - JITTER + 2 * JITTER * random()));
}
